import React from "react";

export type SelectedHeatPumpData = { heatPumpId: number; variantIndex: number };

export const SelectedHeatPumpContext = React.createContext<{
  data: SelectedHeatPumpData;
  setData: (data: SelectedHeatPumpData) => void;
}>({ data: { heatPumpId: 1, variantIndex: 0 }, setData: () => null });
